import React from "react";
import PropTypes from "prop-types";

export default class GeneratedTemplate extends React.Component {
    render() {
        const { data } = this.props;
        const { requestedAt } = data;
        const date = new Date(requestedAt); // Fri Mar 02 2018 18:03:51 GMT+0000 (GMT)
        const dateString = date.toLocaleString(); // 3/2/2018, 6:03:51 PM
        return dateString;
    }
}

GeneratedTemplate.propTypes = {
    data: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./app/lib/hex/lib/resultsview/templates/GeneratedTemplate.js